<section class="home-v2__section home-v2__section--segmentacion" aria-label="¿Es neocrédito para mí?">
  <p class="home-v2__section-placeholder">{{ content.title }} — Fase 9</p>
</section>
